<template>
  <div id="search-location">
    <div id="search-bar" class="select-wrapper">
      <i id="close" class="anyteachicon anyteach-guanbi" @click="$emit('close')" />
      <input v-model="address" type="text" placeholder="输入地址" />
    </div>
    <div v-if="address" class="blue-button button-pop" @click="$emit('location', address)">保存</div>
    <div v-else class="blue-button disabled">保存</div>
  </div>
</template>
<script>
export default {
  name: "SearchLocation",
  data() {
    return {
      address: "",
    }
  },
  methods: {},
}
</script>
<style scoped lang="scss">
// @import "../../../static/css/public.scss";
@import "../../../static/css/prog-form.scss";
@import "../../../static/css/transaction.scss";

#search-location {
  width: 100%;
  padding-top: 127px;
  z-index: 998;
  height: 100vh;
  position: fixed;
  background: white;
  overflow-y: scroll;
  top: 0;
  left: 0;
  .marginal {
    width: 90%;
    margin: auto;
  }
  #container {
    width: 100%;
    height: 300px;
  }
  .empty {
    height: 40vh;
    font-size: 15px;
  }

  // .button {
  //   background: $blue;
  //   color: white;
  //   border-radius: 5px;
  //   margin: 0 5%;
  //   width: 90%;
  //   padding: 15px;
  //   text-align: center;
  //   font-size: 15px;
  //   font-weight: 500;
  // }

  #search-bar {
    padding-top: 20px;
    padding-left: 5%;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background: white;
    /*border: none;*/
    /*box-shadow: $deep-shadow;*/
    textarea,
    input {
      width: 95%;
      font-size: 20px;
      font-weight: 500;
      margin-top: 15px;
      border: 0;
      // border-radius: 0;
      // padding: 0;
    }
    #close {
      margin-left: 0;
      margin-bottom: 0;
    }
  }
  .search-results {
    margin-bottom: 20px;
    .search-item {
      &:active {
        background: #eeeeee;
      }
    }
    .text-container {
      padding: 20px 0;
      width: 95%;
      margin-left: 5%;
      border-bottom: 1px solid #efefef;
    }
    h1 {
      font-size: 15px;
      font-weight: 400;
      padding-bottom: 5px;
      color: $black;
    }
    h2 {
      font-size: 13px;
      font-weight: 400;
      color: $grey;
      line-height: 1.3;
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
  }
}
</style>
